/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Light_Goldfish_FlopInputs */

const fr_free_light_goldfish_flop = /** @type {(inputs: Free_Light_Goldfish_FlopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

/**

* @param {Free_Light_Goldfish_FlopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const free_light_goldfish_flop = /** @type {((inputs?: Free_Light_Goldfish_FlopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Light_Goldfish_FlopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_free_light_goldfish_flop(inputs)
});